import emptyReducer from './emptyReducer';

const fromLbsToKg = (weightLb: number) => `${weightLb}lbs`;

const toWeightLbs = emptyReducer<string | null>(null).with({
  BodyMassIndex: (heightFt, heightIn, weightLb) => (weightLb ? fromLbsToKg(weightLb) : null),
});

export default toWeightLbs;
